module.exports = __webpack_public_path__ + "static/Cover-36da67ff6fdbfdc73908d84a40f50c9d.jpg";